import React, { useState } from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import HelpIcon from '@material-ui/icons/Help';
import IconButton from '@material-ui/core/IconButton';
import MenuItem from '@material-ui/core/MenuItem';
import Menu from '@material-ui/core/Menu';
import AccountCircle from '@material-ui/icons/AccountCircle';
import PowerSettingNew from '@material-ui/icons/PowerSettingsNew';
import Face from '@material-ui/icons/Face';
import { useIntl } from 'react-intl';
import Tabs from './tabs-header';
import Search from './search';
import ChangeThemeSwitch from './change-theme-switch';
import SelectLangage from './select-language';
import { ACTIVE_COLOR } from '../../utils/constants';
import useThemeQuery from '../../graphql/queries/toggle-theme';

const TabPanel = props => {
    const { children, value, index, ...other } = props;

    return (
      <Typography
        component="div"
        role="tabpanel"
        hidden={value !== index}
        id={`scrollable-auto-tabpanel-${index}`}
        aria-labelledby={`scrollable-auto-tab-${index}`}
        {...other}
      >
          <Box p={3}>{children}</Box>
      </Typography>
    );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

const useStyles = makeStyles(theme => ({
  appbar: {
    borderRadius: 10,
    boxShadow: '1px 4px 2px #D8DFE6 0 1px 1px #D8DFE6'
  },
  appbarDark: {
      backgroundColor: '#0b243e',
  },
  appbarLight: {
      backgroundColor: '#fff',
  },
  indicator: {
    backgroundColor: '#1890ff',
  },
  text: {
    color: '#a0aeca'
  },
  helpIcon: {
    color: '#405266',
    fontSize: 14,
    marginLeft: 5
  },
  logoIcon: {
    color: '#fff'
  },
  button: {
    color: '#fff',
    fontSize: 14
  },
  menuItems: {
    marginLeft: 10
  }
}));

const Header = ({ router, location }) => {
    const classes = useStyles();
    const { formatMessage } = useIntl();
    const { data } = useThemeQuery();

    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    const handleMenu = event => {
      setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
      setAnchorEl(null);
    };
  
    const redirectClick = (e, value) => {
      if (value === 'profil') {
        router.push('/profile');
      } else {
        router.push('/logout');
      }
      setAnchorEl(null);
    };

    return (
        <AppBar position="static" color="default" className={clsx(classes.appbar, data && data.theme ? classes.appbarDark: classes.appbarLight)} boxShadow={0}>
            <Box display="flex" alignItems="center" justifyContent="space-between" px={2}>
                <Box display="flex" alignItems="center">
                    <Box display="flex" justifyContent="center" pl={2} pr={5}>
                      <img alt="img" src={`${process.env.PUBLIC_URL}/icons/logo.svg`} />
                    </Box>
                    <Box className={classes.tabs}>
                        <Tabs location={location} router={router}/>          
                    </Box>
                    <Search theme={data && data.theme} />
                </Box>
                <Box display="flex" alignItems="center" justifyContent="flex-start">
                    <Box>
                        <ChangeThemeSwitch/>
                    </Box>
                    <Box display="flex" alignItems="center" px={3}>
                        <Typography className={classes.text}>{formatMessage({id:"app.nav.help", defaultMessage:"Help"})}</Typography>
                        <HelpIcon className={classes.helpIcon}/>
                    </Box>                
                    <Box display="flex" alignItems="center" px={3}>
                        <SelectLangage />
                    </Box>                
                    <Box display="flex" alignItems="center" py={1} px={1.2} borderRadius={7} bgcolor={ACTIVE_COLOR}>
                        <Typography className={classes.button}>LD</Typography>
                    </Box>     
                    <Box>
                      <IconButton
                        aria-label="account of current user"
                        aria-controls="menu-appbar"
                        aria-haspopup="true"
                        onClick={handleMenu}
                        color="inherit"
                        style={{marginLeft: 5}}
                      >
                        <AccountCircle style={{color: data && data.theme ? "#fff" : "#000"}} />
                      </IconButton>
                      <Menu
                        anchorEl={anchorEl}
                        anchorOrigin={{
                          vertical: 'top',
                          horizontal: 'right',
                          backgroundColor: '#000'
                        }}
                        keepMounted
                        transformOrigin={{
                          vertical: 'top',
                          horizontal: 'right',
                        }}
                        open={open}
                        onClose={handleClose}
                      >
                        <MenuItem onClick={e => redirectClick(e, 'profil')}>
                          <Face /> 
                          <Typography className={classes.menuItems}>{formatMessage({id:"app.nav.profil", defaultMessage:"Profil"})}</Typography>
                        </MenuItem>
                        <MenuItem onClick={e => redirectClick(e, 'logout')}>
                          <PowerSettingNew />
                          <Typography className={classes.menuItems}>{formatMessage({id:"app.nav.logout", defaultMessage:"Logout"})}</Typography>
                        </MenuItem>
                      </Menu>
                    </Box>           
                </Box>
            </Box>
        </AppBar>
    );
}

export default Header;